import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NumericFormat } from 'react-number-format';
import { invoicePaymentActions, tagActions } from 'store';
import { AccordionFullTable } from 'components';
import { tagEnums, useModal, formatNumberToFix, FindLoad } from 'utils';
import { completedInvoiceTableInfo, GET_ACTION_TYPE, invoiceStatusEnums } from './constants';
import { AddTransactionModal } from './core';
import { Skeleton } from '@mui/material';

export const CompletedInvoices = () => {
    const invoicePaymentsData = useSelector((state) => state.invoicePayment.invoicePayments);
    const invoiceTotals = useSelector((state) => state.invoicePayment.invoiceTotals);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { open, close } = useModal();
    const loader = FindLoad(GET_ACTION_TYPE);
    const invoices = invoicePaymentsData?.invoices || [];
    const totalAmount = invoiceTotals?.totalAMT ?? invoices.reduce((sum, inv) => sum + (inv?.totalAMT || 0), 0);
    const totalPaid = invoiceTotals?.totalPaid ?? invoices.reduce((sum, inv) => sum + (inv?.paidAMT || 0), 0);
    const totalAdjustments = invoiceTotals?.totalAdjustments ?? invoices.reduce((sum, inv) => sum + (inv?.adjustmentsTotal || 0), 0);

    const renderParams = () => {
        const pushInfo = {
            ...info,
            statuses: [invoiceStatusEnums.PAID, invoiceStatusEnums.CLOSED],
        };
        delete pushInfo.page;
        delete pushInfo.tabType;
        delete pushInfo.clientFull;
        pushInfo.skip = info?.skip ? info?.skip : 0;
        pushInfo.limit = 50;
        return pushInfo;
    };

    const renderTotalsParams = () => {
        const pushInfo = {
            ...info,
            statuses: [invoiceStatusEnums.PAID, invoiceStatusEnums.CLOSED],
        };
        delete pushInfo.page;
        delete pushInfo.tabType;
        delete pushInfo.clientFull;
        delete pushInfo.skip;
        delete pushInfo.limit;
        return pushInfo;
    };

    const getInvoices = (load) => {
        dispatch(invoicePaymentActions.getInvoicePayments({ ...renderParams() }, load));
        dispatch(invoicePaymentActions.getInvoiceTotals({ ...renderTotalsParams() }));
    };

    useEffect(() => {
        getInvoices();
        dispatch(tagActions.getTags({ module: tagEnums.INVOICE }));
    }, [info]);

    const handleAction = (item, actionName) => {
        if (actionName === 'addTxn') {
            open(
                <AddTransactionModal
                    invoice={item}
                    afterSuccess={() => {
                        close();
                        getInvoices('noLoad');
                    }}
                />
            );
        }
    };

    return (
        <div>


            {loader?.length ? (
                <div style={{ margin: '0 0 6px 0' }}>
                    <Skeleton variant="rectangular" width={'100%'} height={60} style={{ borderRadius: '8px' }} />
                </div>
            ) : (
                <div className="aging-section-box" style={{ justifyContent: 'flex-end', gap: 12, margin: '0 0 6px 0' }}>
                    <div className="billing-total-row">
                        <p className="billing-total-title">Total Amount</p>
                        <div className="billing-total-price-row">
                            <NumericFormat
                                value={formatNumberToFix(totalAmount)}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                            />
                        </div>
                    </div>
                    <div className="billing-total-row">
                        <p className="billing-total-title">Total Paid</p>
                        <div className="billing-total-price-row">
                            <NumericFormat
                                value={formatNumberToFix(totalPaid)}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                            />
                        </div>
                    </div>
                    <div className="billing-total-row">
                        <p className="billing-total-title">Total Adjustments</p>
                        <div className="billing-total-price-row">
                            <NumericFormat
                                value={formatNumberToFix(totalAdjustments)}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                            />
                        </div>
                    </div>
                </div>
            )}

            <AccordionFullTable
                margin={'0'}
                tableInfo={completedInvoiceTableInfo(navigate, info, handleAction, renderParams)}
                list={invoicePaymentsData?.invoices}
                listCount={invoicePaymentsData?.count}
                detailPage={(item) => `/invoice/${item?.id}`}
            />
        </div>
    );
};
